const FOOTER_OFFSET_CSS_VAR = "--footer-nav-offset";

const LayoutChromeHook = {
  mounted() {
    this.updateFooterOffset = this.updateFooterOffset.bind(this);

    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => this.updateFooterOffset());
      this.resizeObserver.observe(this.el);
    }

    window.addEventListener("resize", this.updateFooterOffset, { passive: true });

    requestAnimationFrame(() => this.updateFooterOffset());
  },

  updated() {
    this.updateFooterOffset();
  },

  destroyed() {
    this.resizeObserver?.disconnect();
    window.removeEventListener("resize", this.updateFooterOffset);
    document.documentElement.style.removeProperty(FOOTER_OFFSET_CSS_VAR);
  },

  updateFooterOffset() {
    const { height } = this.el.getBoundingClientRect();
    const offset = `${Math.ceil(height)}px`;

    document.documentElement.style.setProperty(FOOTER_OFFSET_CSS_VAR, offset);
  }
};

export default LayoutChromeHook;
